module.exports = __webpack_public_path__ + "static/media/personal-data-billing.7f6e6793.svg";